import RedirectFormLink from '@components/RedirectForm/RedirectFormLink';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './MFELink.module.scss';
const MFELink = ({ to = '', requiresJWT, alwaysExternal, target = '_blank', rel = 'noreferrer', children, ...props }) => {
    // If the url requires a JWT, always redirect them to a new tab and domain (these are external as well)
    if (requiresJWT) {
        return (<RedirectFormLink to={{ redirectTo: to }} className={props.className || styles.link} target={target} data-testid="MFELink-RedirectFormLink" {...props}>
                {children}
            </RedirectFormLink>);
    }
    // If the url should always be external, then don't attempt to break it up (not passing a jwt)
    if (alwaysExternal) {
        return (<Link to={{ pathname: to }} target={target === '_top' ? target : '_blank'} rel={rel} {...props} data-testid="MFELink">
                {children}
            </Link>);
    }
    // Internal redirects
    return (<Link to={to} target={'_self'} rel={rel} {...props} data-testid="MFELink">
            {children}
        </Link>);
};
export default MFELink;
